import { FunctionComponent, useContext, useState } from 'react';

import { MainContainer } from '../../layout/components/MainContainer';
import { TableReassigment } from './components/TableReassigment';
import { IReassigmentProvider } from '../../interfaces/service/ReassignmentServiceManagerInterface';
import { ReassigmentContextSM } from '../../serviceContextManager/reassignment/ReassignmentServiceManager';
import { RightMenu } from './components/RightMenu';

export const Reassigment: FunctionComponent = () => {
  const serviceReassignment =
    useContext<IReassigmentProvider>(ReassigmentContextSM);

  const renderContent = () => {
    return (
      <div className="flex w-full h-full relative flex-row">
        <div className="flex grow h-full relative flex-col content-center items-center overflow-x-auto justify-center p-5">
          <TableReassigment serviceReassignment={serviceReassignment} />
        </div>
      </div>
    );
  };

  const renderRightComponent = () => {
    return <RightMenu serviceReassignment={serviceReassignment} />;
  };

  return (
    <MainContainer
      openRightMenu={serviceReassignment.openRightMenu}
      setOpenRightMenu={serviceReassignment.setOpenRightMenu}
      loading={false}
      rightMenuContent={renderRightComponent}>
      {renderContent()}
    </MainContainer>
  );
};
